import { TableRow, Typography } from "@mui/material";
import { isEmpty, isNil, isObject } from "lodash";
import { CellLabel, CellValue } from "./Cells";
import { SummaryTable } from "./SummaryTable";
import { SnapshotRegion } from "../regions";
import { useSnapshot } from "../SnapshotContext";
import { highlightSearchQuery } from "./utils";

interface MapValueSummaryProps {
  value: Record<string, any> | undefined;
  fieldType: "attribute" | "resource" | "body";
  // The message to display when value is empty or undefined
  emptyMessage: string;
}

export const MapValueSummary: React.FC<MapValueSummaryProps> = ({
  value,
  fieldType,
  emptyMessage,
}) => {
  const { searchRegex } = useSnapshot();

  return isNil(value) || isEmpty(value) ? (
    <Typography
      marginLeft={2}
      marginTop={1}
      fontWeight={300}
      fontSize={14}
      component="span"
      color="gray"
    >
      {emptyMessage}
    </Typography>
  ) : (
    <SummaryTable>
      {isObject(value) ? (
        Object.entries(value).map(([k, v], ix) => {
          return (
            <TableRow
              key={k}
              data-region={SnapshotRegion.FIELD_ROW}
              data-key={k}
              data-value={typeof v === "object" ? undefined : String(v)}
              data-fieldtype={fieldType}
            >
              <CellLabel>{highlightSearchQuery(k, searchRegex)}</CellLabel>
              {typeof v === "object" ? (
                <CellValue whiteSpace="pre-wrap">
                  {highlightSearchQuery(
                    JSON.stringify(v, null, 2),
                    searchRegex,
                  )}
                </CellValue>
              ) : (
                <CellValue whiteSpace="pre-wrap">
                  {highlightSearchQuery(String(v), searchRegex)}
                </CellValue>
              )}
            </TableRow>
          );
        })
      ) : (
        <TableRow>
          <CellValue whiteSpace="pre-wrap">
            {highlightSearchQuery(String(value), searchRegex)}
          </CellValue>
        </TableRow>
      )}
    </SummaryTable>
  );
};
